// header scroll state
const header = document.getElementById('header');
if (header) {
  const onScroll = () => { header.classList.toggle('scrolled', window.scrollY > 40); };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// mobile nav
const burger = document.getElementById('burger');
const mnav = document.getElementById('mnav');
const mclose = document.getElementById('mclose');
if (burger && mnav) {
  burger.addEventListener('click', () => mnav.classList.add('open'));
  if (mclose) mclose.addEventListener('click', () => mnav.classList.remove('open'));
  mnav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mnav.classList.remove('open')));
}

// reveal on scroll
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
}, { threshold: .16, rootMargin: '0px 0px -8% 0px' });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));
